<template>
  <div class="tw-select">
    <label :for="id" class="tw-sr-only tw-block">{{ label }}</label>
    <select :id="id"
            :class="['tw-text-blue', {'tw-text-opacity-50': !value}]"
            v-model="selected">
      <option value="" disabled v-if="!options.length">{{ noResults }}</option>
      <option v-for="option in options"
              :value="option.value"
              :disabled="option.disabled">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'FilterSelect',
  model: {
    event: 'change',
  },
  props: ['value', 'label', 'id', 'options', 'noResults'],
  computed: {
    selected: {
      get() {
        return this.value === undefined ? '' : this.value;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
  },
};
</script>
